// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3QOEs","topBottomGutter":"Layout_topBottomGutter__T2i_n"};